module.exports = __webpack_public_path__ + "static/media/typeThree.8c45e9c4.png";